export default {"id":"e60611f3","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}